import { datetimeCovertertolocal } from '../../datetime-converter';
import {
	DETECTIONCLUSTER_LIST, DETECTIONCLUSTER_LIST_SUCCESS, DETECTIONCLUSTER_LIST_ERROR,
	DETECTIONCLUSTER_DETAILS, DETECTIONCLUSTER_DETAILS_SUCCESS, DETECTIONCLUSTER_DETAILS_ERROR,
	ADD_DETECTIONCLUSTER, ADD_DETECTIONCLUSTER_SUCCESS, ADD_DETECTIONCLUSTER_ERROR,
	UPDATE_DETECTIONCLUSTER, UPDATE_DETECTIONCLUSTER_SUCCESS, UPDATE_DETECTIONCLUSTER_ERROR,
	DELETE_DETECTIONCLUSTER, DELETE_DETECTIONCLUSTER_SUCCESS, DELETE_DETECTIONCLUSTER_ERROR,
	DETECTIONALG_LIST, DETECTIONALG_LIST_SUCCESS, DETECTIONALG_LIST_ERROR
} from './constants';

// TODO: adjust this import to wherever datetimeCovertertolocal lives in your project


// jsonb columns may arrive as arrays or as JSON strings
const toArray = (value) => {
	if (Array.isArray(value)) return value;
	if (typeof value === 'string') {
		try {
			const parsed = JSON.parse(value);
			return Array.isArray(parsed) ? parsed : [];
		} catch (e) {
			return [];
		}
	}
	return [];
};

// UTC / ISO string -> "localdate localtime", same approach as TASK_LIST_SUCCESS
const formatLocal = (value) => {
	if (!value) return '<Not Set>';
	const converted = datetimeCovertertolocal(value);
	return converted.localdate + ' ' + converted.localtime;
};

export default function detectionClusterReducer(state, action) {
	switch (action.type) {
	case DETECTIONCLUSTER_LIST:
		return { ...state, pending: true };

	case DETECTIONCLUSTER_LIST_SUCCESS: {
		const payload = action.payload;

		const pagination = {
			total: payload?.total ?? 0,
			limit: payload?.limit ?? 10,
			skip: payload?.skip ?? 0,
			current: action.page ?? 1,
			pageSize: action.pageSize ?? 10,
		};

		if (payload?.data?.length > 0) {
			const clusters = payload.data.map((item) => ({
				id: item.id,
				eventType: item.eventType ? item.eventType : '',
				detectionalgorithmtypeId: item.detectionalgorithmtypeId ?? null,
				detectionalgname: item.detectionalgorithmtype?.name ? item.detectionalgorithmtype.name : '_',
				pidsinfoId: item.pidsinfoId ?? null,
				pidsname: item.pidsinfo?.name ? item.pidsinfo.name : '',
				channelId: item.channelId ?? null,
				channelname: item.channelinfo?.name ? item.channelinfo.name : (item.channelId ?? ''),
				trackType: item.trackType ? item.trackType : null,

				// formatted for the table
				starttime: formatLocal(item.starttime),
				endtime: formatLocal(item.endtime),
				seeddatetime: formatLocal(item.seeddatetime),

				// raw values, used to pre-fill the edit form
				starttimeUTC: item.starttime,
				endtimeUTC: item.endtime,
				seeddatetimeUTC: item.seeddatetime,

				seedStartDistance: item.seedStartDistance ?? null,
				seedEndDistance: item.seedEndDistance ?? null,
				status: item.status ? item.status : '',

				// arrays shown as tags
				sourceTimeStart: toArray(item.sourceTimeStart).map(formatLocal),
				sourceTimeEnd: toArray(item.sourceTimeEnd).map(formatLocal),
				sourceLatitude: toArray(item.sourceLatitude),
				sourceLongitude: toArray(item.sourceLongitude),
				sourceDistances: toArray(item.sourceDistances),
				fiberDistance: toArray(item.fiberDistance),
				fiberLatitude: toArray(item.fiberLatitude),
				fiberLongitude: toArray(item.fiberLongitude),

				createdAt: item.createdAt ? item.createdAt : '',
				updatedAt: item.updatedAt ? item.updatedAt : '',
			}));

			return { ...state, clusters, pagination, pending: false, error: false };
		}

		if (payload?.data?.length === 0) {
			return { ...state, clusters: [], pagination, pending: false, error: false };
		}

		return { ...state, clusters: [], pending: false, error: true };
	}

	case DETECTIONCLUSTER_LIST_ERROR:
		return { ...state, clusters: [], pending: false, error: true };

	case DETECTIONCLUSTER_DETAILS:
		return { ...state, pending: true };

	case DETECTIONCLUSTER_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case DETECTIONCLUSTER_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_DETECTIONCLUSTER:
	case UPDATE_DETECTIONCLUSTER:
	case DELETE_DETECTIONCLUSTER:
		return { ...state, pending: true };

	case ADD_DETECTIONCLUSTER_SUCCESS:
	case UPDATE_DETECTIONCLUSTER_SUCCESS:
	case DELETE_DETECTIONCLUSTER_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_DETECTIONCLUSTER_ERROR:
	case UPDATE_DETECTIONCLUSTER_ERROR:
	case DELETE_DETECTIONCLUSTER_ERROR:
		return { ...state, pending: false, error: true };

	case DETECTIONALG_LIST:
		return { ...state, loading: true, error: false };

	case DETECTIONALG_LIST_SUCCESS: {
		const detalg = (action.payload?.data ?? []).map((item) => ({
			id: item?.id ?? null,
			name: item?.name ?? '',
		}));
		return { ...state, detalg, loading: false, error: false };
	}

	case DETECTIONALG_LIST_ERROR:
		return { ...state, detalg: [], loading: false, error: true };

	default:
		throw Error('Unknown action: ' + action.type);
	}
}